import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full max-w-xl flex-col items-center gap-6 px-6 py-12 text-center" }
const _hoisted_2 = { class: "flex flex-col items-center text-secondary" }
const _hoisted_3 = { class: "text-2xl font-medium" }
const _hoisted_4 = { class: "text-muted-foreground" }
const _hoisted_5 = { class: "flex flex-wrap justify-center gap-3" }

import AppLayout from '@/layouts/AppLayout.vue';
    import PageCard from '@/components/PageCard.vue';
    import { Button } from '@/components/ui/button';
    import { Head } from '@inertiajs/vue3';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Forbidden',
  setup(__props) {

    const canGoBack = computed(() => !!window.history.length);

    function goBack() {
        if (canGoBack.value) {

            window.history.back();
            return;
        }

        window.location.href = route('v2.index');
    }
    function goHome() {

        window.location.href = route('v2.index');
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), { title: "403" }),
    _createVNode(AppLayout, { "hide-header": true }, {
      default: _withCtx(() => [
        _createVNode(PageCard, { class: "flex min-h-[70vh] items-center justify-center bg-background p-0" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-4xl font-semibold" }, "403", -1)),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('errors.403.title')), 1)
              ]),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('errors.403.description')), 1),
              _createElementVNode("div", _hoisted_5, [
                (canGoBack.value)
                  ? (_openBlock(), _createBlock(_unref(Button), {
                      key: 0,
                      variant: "outline",
                      onClick: goBack
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('forms.previous')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(Button), { onClick: goHome }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('forms.home')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})